import { AiAgents, AiTeamsImpact, CaseStudies, Departments, DepartmentsProjectsTest, MondayDifference, Products, Security, Trust, Closer, Logos, Hero, HeroFu, Magic } from "devlink";
import { FIELD_TYPES } from "constants/template-field-type";
export const DEVLINK_COMPONENT_CONFIGS = {
    Hero: {
        component: Hero,
        props: {
            buttonBottomLabel: {
                type: FIELD_TYPES.TEXT,
                label: "Button Bottom Label",
                translatable: true
            },
            buttonLabelVisibility: {
                type: FIELD_TYPES.BOOLEAN,
                label: "Show Button Label"
            }
        }
    },
    HeroFu: {
        component: HeroFu,
        props: {}
    },
    Products: {
        component: Products,
        props: {}
    },
    Departments: {
        component: Departments,
        props: {}
    },
    DepartmentsProjectsTest: {
        component: DepartmentsProjectsTest,
        props: {}
    },
    AiTeamsImpact: {
        component: AiTeamsImpact,
        props: {}
    },
    Trust: {
        component: Trust,
        props: {}
    },
    Security: {
        component: Security,
        props: {}
    },
    AiAgents: {
        component: AiAgents,
        props: {}
    },
    CaseStudies: {
        component: CaseStudies,
        props: {}
    },
    MondayDifference: {
        component: MondayDifference,
        props: {}
    },
    Closer: {
        component: Closer,
        props: {}
    },
    Logos: {
        component: Logos,
        props: {}
    },
    Magic: {
        component: Magic,
        props: {}
    }
};
